import styled from "styled-components";

export const ResumeContainer = styled.div`
  padding-top: 100px;
  background: ${({ light }) => (light ? "white" : "#0a0806")};
`;

export const ResumeSubContainer = styled.div`
  display: grid;
  grid-template-columns: 17% 83%;

  @media screen and (max-width: 1010px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ResumeContentDivContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
`;

export const ResumeWrapper = styled.div`
  margin: 0 auto;

  @media screen and (max-width: 960px) {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ResumeAside = styled.aside`
  padding: 0 40px;
  position: sticky;
  padding-bottom: 70px;
  top: 50%;
  @media screen and (max-width: 960px) {
    padding: 0px;
    align-items: center;
  }
`;

export const ResumeDivDestrezas = styled.div`
  @media screen and (max-width: 820px) {
    margin-bottom: 20px;
  }
`;

export const ResumeList = styled.ul`
  list-style: none;
  border-left: 2px solid ${({ light }) => (light ? "#0a0806" : " #c9c9c9")};
  padding: 0 0 0 20px;
`;

export const ResumeListItem = styled.li`
  position: relative;

  .active {
    color: #5dc1b9 !important;
    ::before {
      content: "";
      display: block;
      height: 12px;
      width: 12px;
      position: absolute;
      left: -29px;
      top: calc(50% - 6px);
      border: 2px solid #239089;
      transform: rotate(45deg);
      background-color: #8ae0db;
    }
  }

  &:hover {
    ::before {
      content: "";
      display: block;
      height: 12px;
      width: 12px;
      position: absolute;
      left: -29px;
      top: calc(50% - 6px);
      border: 2px solid #497e76;
      transform: rotate(45deg);
    }
  }

  ::before {
    content: "";
    display: block;
    height: 12px;
    width: 12px;
    background-color: ${({ light }) => (light ? " #8c8c8c" : " #f7f8fa")};
    position: absolute;
    left: -29px;
    top: calc(50% - 6px);
    border: 2px solid;
    transform: rotate(45deg);
  }
`;

export const ResumeLink = styled.a`
  display: block;
  text-decoration: none;
  color: ${({ light }) => (light ? " #0a0806" : " #f7f8fa")};
  font-size: 16px;
  padding-top: 15px;
  padding-left: 5px;
  padding-bottom: 15px;
  font-weight: bold;

  &.active {
    color: ${({ light }) => (light ? " #d32f2f" : " #1b7b71")} !important;
    ::before {
      content: "";
      display: block;
      height: 12px;
      width: 12px;
      position: absolute;
      left: -29px;
      top: calc(50% - 6px);
      border: 2px solid ${({ light }) => (light ? " #d32f2f" : " #8ae0db")};
      transform: rotate(45deg);
      background-color: ${({ light }) => (light ? " #ef9a9a" : " #239089")};
    }
  }

  &:hover {
    color: ${({ light }) => (light ? " #ef5350" : " #1b7b71")} !important;
  }

  ::before {
    content: "";
    display: block;
    height: 12px;
    width: 12px;
    position: absolute;
    left: -29px;
    top: calc(50% - 6px);
    border: 2px solid #497e76;
    transform: rotate(45deg);
    background-color: ${({ light }) => (light ? " #b5b5b5" : " #dcdcdc")};
  }
`;

export const ResumeTitle = styled.h1`
  color: ${({ light }) => (light ? " #c62828" : " #52b2bf")};
  font-size: 80px;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  text-align: center;

  &:hover {
    transition: all 0.4s ease-out;
    transform: scale(1.2);
  }

  @media screen and (max-width: 820px) {
    margin-bottom: 20px;
    font-size: 50px;
  }
`;
